import { render, staticRenderFns } from "./QuotationStepForm.vue?vue&type=template&id=2bb75b7b&scoped=true"
import script from "./QuotationStepForm.vue?vue&type=script&lang=js"
export * from "./QuotationStepForm.vue?vue&type=script&lang=js"
import style0 from "./QuotationStepForm.vue?vue&type=style&index=0&id=2bb75b7b&prod&lang=scss&scoped=true"
import style1 from "./QuotationStepForm.vue?vue&type=style&index=1&id=2bb75b7b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb75b7b",
  null
  
)

export default component.exports